<template>
  <div class="row">
    <div v-if="showPalette" class="col-sm-2">
      <div class="edition-panel">
        <draw-button-palette
          :can-add-shapes="canAddMoreShapes"
          :draw-mode="drawingManager ? drawingManager.drawingMode : null"
          :drawing-modes="drawingModes"
          :outline="true"
          :btn-block="true"
          :show-undo="!!lastShape"
          :show-delete="shapeLimit > 1"
          :disable-delete="!selectedShape"
          @mode="setMode"
          @undo="undo"
          @deleteSelected="deleteSelectedShape"
          @deleteAll="deleteShapes"
        >
        </draw-button-palette>

        <div class="row color-palette mt-3">
          <div v-for="(color, key) in colors" :key="key" class="col-sm-3">
            <div
              class="color-button mb-2"
              :class="{ active: selectedColor === color }"
              :style="{ 'background-color': color, border: `2px solid ${color}` }"
              @click="useColor(color)"
            ></div>
          </div>
        </div>
      </div>
    </div>
    <div v-else-if="showFloatButtons" class="floating-panel">
      <draw-button-palette
        :can-add-shapes="canAddMoreShapes"
        :draw-mode="drawingManager ? drawingManager.drawingMode : null"
        :drawing-modes="drawingModes"
        :show-undo="!!lastShape"
        :show-delete="shapeLimit > 1"
        :disable-delete="!selectedShape"
        @mode="setMode"
        @undo="undo"
        @deleteSelected="deleteSelectedShape"
        @deleteAll="deleteShapes"
      >
      </draw-button-palette>
    </div>
    <div :class="{ 'col-sm-10': showPalette, 'col-sm-12': !showPalette }">
      <div :id="mapId" class="map-canvas"></div>
    </div>
  </div>
</template>

<script>
import initMapMixin from '../../../mixins/initMapMixin';
import drawingMapMixin from '../../../mixins/drawingMapMixin';
import DrawButtonPalette from './DrawButtonPalette';

export default {
  components: {
    DrawButtonPalette,
  },

  mixins: [initMapMixin, drawingMapMixin],
  props: {
    defaultCoordinates: {
      type: Array,
      default: null,
    },

    showPalette: {
      type: Boolean,
      default: true,
    },

    showFloatButtons: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      drawingModes: [],
      defaultMarker: null,
    };
  },

  computed: {
    canAddMoreShapes() {
      return this.shapes.length < this.shapeLimit;
    },
  },

  updated() {
    this.showTools(this.canAddMoreShapes);
  },

  methods: {
    mapLoaded() {
      this.drawingModes.push(this.google.maps.drawing.OverlayType.POLYGON);

      const vm = this;
      this.drawingManager = new this.google.maps.drawing.DrawingManager({
        drawingMode: this.google.maps.drawing.OverlayType.POLYGON,
        drawingControl: true,
        drawingControlOptions: {
          position: this.google.maps.ControlPosition.TOP_CENTER,
          // MARKER CIRCLE POLYLINE RECTANGLE POLYGON
          drawingModes: [this.google.maps.drawing.OverlayType.POLYGON],
        },

        polygonOptions: { strokeWeight: 2, fillOpacity: 0.45, editable: true },
      });

      this.google.maps.event.addListener(this.map, 'click', this.clearSelection);
      this.google.maps.event.addListener(this.drawingManager, 'drawingmode_changed', this.clearSelection);
      this.google.maps.event.addListener(this.drawingManager, 'overlaycomplete', (e) => {
        if (e.type !== vm.google.maps.drawing.OverlayType.MARKER) {
          vm.drawingManager.setDrawingMode(null);

          const newShape = e.overlay;
          newShape.type = e.type;

          vm.addShape(newShape);

          const coordinates = this.getCoordinates(newShape);
          const center = this.calculateCenter(coordinates);

          this.$emit('shapeAdded', coordinates, center);
          this.removeDefaultMarker();
        }
      });

      this.drawingManager.setMap(this.map);
      this.selectColor(this.colors[0]);

      this.setDefaultCoordinates();
    },

    setDefaultCoordinates() {
      if (this.defaultCoordinates && this.defaultCoordinates.length > 0 && this.location) {
        this.drawingManager.setDrawingMode(null);

        const shapeToAdd = new google.maps.Polygon({
          paths: this.defaultCoordinates,
          strokeColor: this.colors[0],
          strokeOpacity: 0.8,
          strokeWeight: 2,
          fillColor: this.colors[0],
          fillOpacity: 0.45,
          editable: true,
          visible: true,
        });

        shapeToAdd.setMap(this.map);
        this.addShape(shapeToAdd);
      } else if (this.defaultLat && this.defaultLng) {
        this.defaultMarker = new this.google.maps.Marker({
          position: this.location,
          draggable: false,
          map: this.map,
          animation: this.google.maps.Animation.DROP,
          title: 'Ubicación del lote',
        });
      }
    },

    removeDefaultMarker() {
      if (this.defaultMarker) {
        this.defaultMarker.setMap(null);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.map-canvas {
  height: 100vh;
}

.floating-panel {
  position: absolute;
  top: 8%;
  right: 5%;
  z-index: 5;
  background-color: #fff;
  padding: 5px 15px 5px 15px;
  border: 1px solid #cacaca;
  text-align: center;
  font-family: 'Roboto', 'sans-serif';
  line-height: 30px;
}

.color-button {
  width: 20px;
  height: 20px;
  border-radius: 50px;
  font-size: 0;
  cursor: pointer;

  &.active {
    border: 2px solid #789789 !important;
  }
}
</style>
